


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { PeriodsData, DateRangePickerData } from '@/mixins/requests/academy/StudyListApis.vue'
import moment from 'moment'

@Component
export default class DatePickerBase extends Vue {
  @Prop({ default: { startDate: '', endDate: '' } })
  range!: PeriodsData

  @Prop()
  rangeId!: number

  @Prop({ default: false })
  clearButton!: boolean

  @Prop({ default: '' })
  placeholderStart!: string

  @Prop({ default: '' })
  placeholderEnd!: string

  @Prop({ default: null })
  bgColor?: string | null

  @Prop({ default: false })
  disabled?: boolean

  @Prop({ default: 'date' })
  mode!: string

  @Prop({ default: 'YYYY/MM/DD' })
  format!: string

  private currentDate: DateRangePickerData = this.stringToDate(this.range)

  // range propsのウォッチャー
  @Watch('range')
  public onDateChanged(newRange: PeriodsData) {
    this.currentDate = this.stringToDate(newRange)
  }

  get selectedDate(): DateRangePickerData {
    if (!this.currentDate) return null
    return { start: this.currentDate.start, end: this.currentDate.end }
  }

  set selectedDate(range: DateRangePickerData) {
    this.currentDate = range
    this.$emit('input', this.rangeId, this.dateToString(range))
  }

  /**
   * 文字列から日付型へ変換
   */
  private stringToDate(range: PeriodsData): DateRangePickerData {
    if (!range.startDate || !range.endDate) return null
    return { start: new Date(range.startDate as string), end: new Date(range.endDate as string) }
  }

  /**
   * 日付型から文字列へ変換
   */
  private dateToString(dateRange: DateRangePickerData): PeriodsData {
    if (dateRange === null) return { startDate: '', endDate: '' }
    return {
      startDate: moment(dateRange.start).format(this.format),
      endDate: moment(dateRange.end).format(this.format),
    }
  }

  /**
   * テスト情報初期値
   */
  private clearDate(): void {
    this.selectedDate = null
  }

  private get masks(): { [key: string]: string } {
    return { input: this.format }
  }

  /**
   * dateTimeモードはmasksが上手く動作しないのでパースする
   */
  private parseDateTime(dateStr: string) {
    if (this.mode !== 'dateTime') return dateStr
    const match = /(\d{4})年(\d{1,2})月(\d{1,2})日\s(\d{2}):(\d{2})/.exec(dateStr)
    if (!match) return ''
    return moment(
      new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]), parseInt(match[4]), parseInt(match[5]))
    ).format(this.format)
  }
}
